import React, { FC } from "react";
import { Control, UseFieldArrayRemove } from "react-hook-form";
import RemoveItem from "app/components/common/buttons/RemoveItem";
import InputField from "app/components/common/inputs/InputField";
import FormGroup from "app/components/common/inputs/FormGroup";

interface FieldItem {
  id: string;
  dbId?: string;
}
interface Props {
  control: Control<any>;
  errors: any;
  fields: FieldItem[];
  deleteItem: any;
  otherLiabilities: string;
  remove: UseFieldArrayRemove;
  applicantID: string;
  deleteIsPending?: boolean;
}

const DynamicOtherLiabilities: FC<Props> = ({
  control,
  errors,
  fields,
  otherLiabilities,
  deleteItem,
  applicantID,
  remove,
  deleteIsPending = false,
}) => {
  const getErrorMessage = (fieldName: string) => {
    const fieldNames = fieldName.split(".");
    return fieldNames.reduce((acc, key) => acc && acc[key], errors);
  };
  return (
    <>
      {fields.map((field, index) => {
        const basePath = `${otherLiabilities}.${index}`;
        return (
          <>
            <FormGroup key={field.id} className="relative">
              <InputField
                label={`Lender name`}
                name={`${basePath}.name`}
                control={control}
                type="text"
                required={true}
                placeholder="Marvin McKinney"
                error={getErrorMessage(`${basePath}.name`)?.message as string}
                className="flex-1"
              />{" "}
              <InputField
                label={`Balance owing`}
                name={`${basePath}.balanceOwing`}
                control={control}
                type="number"
                required={true}
                placeholder="$854.08"
                error={
                  getErrorMessage(`${basePath}.balanceOwing`)?.message as string
                }
                className="flex-1"
                rules={{
                  min: {
                    value: 1,
                    message: "value must be greater than 0",
                  },
                }}
              />
              <InputField
                label={`Min. monthly payment`}
                name={`${basePath}.minMonthlyPayment`}
                control={control}
                type="number"
                required={true}
                placeholder="$406.27"
                error={
                  getErrorMessage(`${basePath}.minMonthlyPayment`)
                    ?.message as string
                }
                className="flex-1"
                rules={{
                  min: {
                    value: 1,
                    message: "value must be greater than 0",
                  },
                }}
              />
              {index > 0 && (
                <RemoveItem
                  className="absolute right-0"
                  disabled={deleteIsPending}
                  onClick={() => {
                    if (field?.dbId) {
                      deleteItem(
                        `/asset-liability/${applicantID}/otherliability/${field?.dbId}`,
                        {
                          onSuccess: () => {
                            remove(index);
                          },
                        }
                      );
                    } else {
                      remove(index);
                    }
                  }}
                />
              )}
            </FormGroup>
          </>
        );
      })}
    </>
  );
};

export default DynamicOtherLiabilities;
